var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$can('read', 'ivr-gateway'))?_c('main-content',[_c('manage-ivr')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }